import './content-image.scss';
